import { IHttpApi } from '@cian/http-api';
import { IConfig } from '@cian/config/shared';

import {
  fetchGetChart,
  IGetChartResponse200,
  IGetChartResponse400,
  EDataType,
  EGeoName,
  ECategory,
} from '../../repositories/valuation-market-analytics/v1/get-chart';

export interface IGetChartRequestParams {
  category: ECategory;
  geoName: EGeoName;
  dataType: EDataType;
}

export interface IGetChartParams {
  httpApi: IHttpApi;
  config: IConfig;
  parameters: IGetChartRequestParams;
}

export function getChart({
  httpApi,
  config,
  parameters,
}: IGetChartParams): Promise<IGetChartResponse200 | IGetChartResponse400> {
  return fetchGetChart({
    httpApi,
    parameters,
    config: {
      ecnhancersConfig: {
        timeout: config.get<number>('getChartTimeout.value') || 5000,
      },
    },
  });
}
